const LAST_TABLE_KEY = 'tp:last-table-profile';

/** Persist last played table profile (survives browser restarts). */
export function saveLastPlayedTable(tableProfileId: number): void {
  const id = Math.floor(Number(tableProfileId));
  if (!Number.isFinite(id) || id <= 0) return;
  localStorage.setItem(LAST_TABLE_KEY, String(id));
}

export function readLastPlayedTable(): number | null {
  const raw = localStorage.getItem(LAST_TABLE_KEY);
  if (!raw) return null;
  const id = Math.floor(Number(raw));
  if (!Number.isFinite(id) || id <= 0) return null;
  return id;
}

export function clearLastPlayedTable(): void {
  localStorage.removeItem(LAST_TABLE_KEY);
}
